/**
 * landing/trending 인기 가이드 섹션의 chip nav island (구 L-03, 2026-05 흡수).
 *
 * Mount: `<nav data-mount="category-filter">` 안 `<button data-category="...">`,
 *        landing/trending trending grid 의 `[data-category]` tile 들과 같은 섹션에서.
 *
 * 흐름:
 *   - 칩 클릭 → 해당 카테고리 외 tile 의 `hidden` 속성 = true,
 *     매칭 tile 은 hidden = false. "all" 칩은 전체 노출.
 *   - 활성 칩 `data-active="true"`, 나머지는 `data-active="false"`.
 *   - DOM only, fetch 0.
 */

const TILE_SELECTOR = "[data-trending-tile]";

function applyFilter(category: string): void {
  const tiles = document.querySelectorAll<HTMLElement>(TILE_SELECTOR);
  for (const t of tiles) {
    if (category === "all") {
      t.hidden = false;
      continue;
    }
    // data-category 누락된 tile 은 ALL 외엔 항상 hidden (안전 default).
    const own = t.dataset.category;
    t.hidden = own !== category;
  }
}

function setActiveChip(nav: HTMLElement, chosen: HTMLButtonElement): void {
  for (const b of nav.querySelectorAll<HTMLButtonElement>("button[data-category]")) {
    b.dataset.active = b === chosen ? "true" : "false";
    b.setAttribute("aria-pressed", b === chosen ? "true" : "false");
  }
}

export function mountCategoryFilter(nav: HTMLElement): void {
  for (const btn of nav.querySelectorAll<HTMLButtonElement>("button[data-category]")) {
    btn.addEventListener("click", () => {
      const category = btn.dataset.category ?? "all";
      applyFilter(category);
      setActiveChip(nav, btn);
    });
  }
}
